import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import D4yTable from '@/components/d4y-table/d4y-table.vue';
import { Logger } from 'fsts';
import { namespace } from 'vuex-class';
import searchData, { SearchData } from '@/shared/model/smallPayloadModels/searchData';
import { ROUTES } from '@/router/routesEnum';
//import zrStat, { StatusIndices as ZrStatus, zrStatusesList } from '@/shared/model/smallPayloadModels/zrStatus';
import DateField from '@/components/_common/date-field/DateField.vue';
import { CONST } from '@/shared/utils/Constants';
//import { UserData } from '@/shared/model/userData';
import StatusDialog from './status-dialog/status-dialog.vue';
import { DefaultBackendHelper } from '@/shared/utils/backendHelper';
import GeneralUtils from '@/shared/utils/generalUtils';
import SupplierTooltip from './search-form/supplier-tooltip/supplier-tooltip.vue';
import { AdmpNews } from '@/shared/model/admpNews';
import { NewsService } from '../../../utils/newsHelper';
import SearchFormAdmpNews from './admp-news-search-form/search-form-admp-news.vue';
import admpNewsSearchData, { AdmpNewsSearchData } from '@/shared/model/smallPayloadModels/admpNewsSearchData';
import { idMask } from '@/components/idMaskService';
import { CompanyZrResult } from '@/shared/model/company';

const logger = new Logger('login');
const authModule = namespace('auth');
const userDataModule = namespace('userData');
const admpNewsModule = namespace('admpNews');
const contactModule = namespace('contact');

@Component({
  components: { D4yTable, SearchFormAdmpNews },
})
export default class AdmpNewsList extends Vue {
  @authModule.Action('canSeeAll')
  private actionCanSeeAll!: any;
  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserInAzureAdminGroupGetter!: any;
  @authModule.Getter('isGlobalAdmin')
  private isGlobalAdmin!: any;
  @authModule.Getter('isUserGsUser')
  private isUserGsUser!: any;
  @authModule.Getter('isUserOnlyGs')
  private isUserOnlyGs!: any;
  @authModule.Getter('zrNummer')
  private zrNummer!: any;
  @authModule.Getter('contactType')
  private contactType!: any;
  @authModule.Getter('zrNummerWithRoles')
  private zrNummerWithRoles!: any;
  @authModule.Getter('isUserSupport')
  private isUserSupport!: any;
  @authModule.Getter('isInitialRedirect')
  private isInitialRedirectGetter!: any;
  @authModule.Getter('supplierTooltipInfo')
  private supplierTooltipInfo!: any;
  @authModule.Getter('isProductionEnv')
  private isProductionEnv!: any;
  @authModule.Getter('getEnvironment')
  private getEnvironment: any;
  @authModule.Getter('isUserInAzureAdminGroup')
  private isUserInAzureAdminGroup!: any;
  @admpNewsModule.Action('updateAdmpNewsSearchData')
  private actionUpdateAdmpNewsSearchData!: any;
  @contactModule.Getter('getContactForLoggedInUser')
  private contactForLoggedInUser!: any;

  @admpNewsModule.Action('getAdmpNewsList')
  private actionGetAdmpNewsList!: any;
  @admpNewsModule.Getter('getAdmpNews')
  private getAdmpNews!: any;
  @admpNewsModule.Getter('getAdmpNewsSearchData')
  private getAdmpNewsSearchData!: any;
  @admpNewsModule.Getter('getAdmpNewsIsLoading')
  private admpNewsIsLoading!: boolean;
  @admpNewsModule.Getter('getAdmpNewsSearchParams')
  private admpNewsSearchParams!: any;
  @admpNewsModule.Action('deleteAdmpNews')
  private actionDeleteAdmpNews!: any;

  @admpNewsModule.Action('upsertAdmpNewsReadInfo')
  private actionUpsertAdmpNewsReadInfo!: any;
  @admpNewsModule.Action('updateUnreadNews')
  private actionUpdateUnreadNews!: any;

  @contactModule.Action('getCompanyZr')
  private actionGetCompanyZrNums!: any;
  @contactModule.Getter('getCompanyZrs')
  private companyZrNumsGetter!: any;
  @contactModule.Getter('getSearchData')
  private searchData!: SearchData;

  @admpNewsModule.Action('markAdmpNewsIsLoaded')
  private actionMarkAdmpNewsIsLoaded!: any;

  @admpNewsModule.Action('getNewsFileDownloadLink')
  private actionGetNewsFileDownloadLink!: any;
  @admpNewsModule.Action('updateAdmpNewsImages')
  private actionUpdateAdmpNewsImages!: any;
  @admpNewsModule.Getter('getAdmpNewsImages')
  private getAdmpNewsImages!: any;

  page = 1;
  tableView = false;
  private loadedImageVersions: Record<number, string | number> = {};

  get pageCountTiles() {
    const modulusRounding = this.getAdmpNews.total % 12 == 0 ? 0 : 1;
    return Math.floor(this.getAdmpNews.total / 12) + modulusRounding;
  }

  changePageTiles(value: any) {
    console.log('changePageTiles :>> ', value);
    this.admpNewsSearchParams.dataOption.page = value;
  }

  get userHasCompany() {
    return this.companyZrNumsGetter?.total > 0;
  }

  get dynamicNewsIteratorHeight() {
    if (this.$vuetify.breakpoint.xlOnly && this.$vuetify.breakpoint.width > 1980) {
      return 380;
    }
    if (this.$vuetify.breakpoint.xlOnly && this.$vuetify.breakpoint.width <= 1980) {
      return 430;
    } else if (
      this.$vuetify.breakpoint.lgOnly &&
      this.$vuetify.breakpoint.width > 1580 &&
      this.$vuetify.breakpoint.width <= 1920
    ) {
      return 430;
    } else if (this.$vuetify.breakpoint.lgOnly && this.$vuetify.breakpoint.width < 1580) {
      return 430;
    } else if (this.$vuetify.breakpoint.mdOnly) {
      return 430;
    } else if (this.$vuetify.breakpoint.smOnly && this.$vuetify.breakpoint.width < 965) {
      return 430;
    }

    return 380;
  }

  async getCompanyZrsFromBackend(contactType: string) {
    // Use existing data from getter if available
    if (this.companyZrNumsGetter?.total > 0) {
      logger.log('Companies already loaded from getter:', this.companyZrNumsGetter);
      return this.companyZrNumsGetter;
    }

    const payload = {
      isInSuperAdminOrSupportGroup: false,
      contactType: contactType,
      IsActive: this.searchData.isActive ?? true,
      isIntern: this.searchData.isIntern ?? false,
    };
    await this.actionGetCompanyZrNums(payload)
      .then((result: CompanyZrResult[]) => {
        logger.log(
          '----------------------actionGetCompanyZrNums--------------------------------------  ===>>>result :>> ',
          result
        );
        // this.сompanyZrs = result;
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  itemsPerPage = 12;
  changeNewsView(value: any) {
    this.tableView = value;
  }
  //#endregion

  private searchPayload: AdmpNewsSearchData = admpNewsSearchData.defaultData();
  @Watch('getAdmpNewsSearchData', { deep: true })
  public async onSearchDataChanged(newVal: AdmpNewsSearchData, oldVal: AdmpNewsSearchData) {
    if (this.isQueryBeforeCreatedDataLoad) return;

    const areObjectsEqual = GeneralUtils.areObjectsEqual(newVal, oldVal, ['isUserInAzureAdminGroup', 'zrNummer']);
    if (areObjectsEqual) return;

    let payload: any = {
      searchData: {
        favorite: newVal.favorite,
        status: newVal.status,
        datum: newVal.datum,
      },
    };

    this.searchPayload = payload.searchData;
    this.actionUpdateAdmpNewsSearchData(payload.searchData);
    localStorage.setItem('admpNewsSignalR', JSON.stringify(payload));

    if (this.admpNewsSearchParams.dataOption.page !== 1) {
      this.admpNewsSearchParams.dataOption.page = 1;
    } else {
      await this.getNewsData();
    }
  }

  @Watch('admpNewsSearchParams.dataOption.page')
  public async onPageChanged(newPage: number, oldPage: number) {
    if (this.isQueryBeforeCreatedDataLoad) return;
    if (newPage === oldPage) return;
    await this.getNewsData();
  }

  get zrNummersCompanies() {
    let result = this.companyZrNumsGetter?.items.map((x: any) => x.zrNummer)?.join(',') || '';
    return result;
  }

  get getZrNummerDependOnRole() {
    let result = this.isUserOnlyGs ? this.zrNummersCompanies || '-' : '';
    return result;
  }
  get isUserLoggedInAndHasRights() {
    return (
      this.isUserInAzureAdminGroupGetter || (this.isUserGsUser && this.userHasCompany) //&& this.isUserHasRightsForDocuments // (GSP-448) also removed `!isUserHasRightsForDocuments` from HTML `v-else-if`
    );
  }

  // avoid extra query from watcher on initial page load
  get newsLoaded() {
    return this.admpNewsIsLoading !== undefined;
  }
  get isQueryBeforeCreatedDataLoad() {
    return this.admpNewsIsLoading === undefined;
  }

  get tableText() {
    return `${this.getAdmpNews.total} Mitteilungen`;
  }

  get initialRedirect() {
    return this.isInitialRedirectGetter;
  }

  get searchMenuObj() {
    return {
      // facetSearch: this.facetSearch,
      menuDisabled: true,
      // menuItems: this.menuItems,
      // hasResults: this.hasResults,
      // chipData: this.chipData,
    };
  }

  newsProdHideLimit = new Date(2024, 11, 3, 22, 0); // months from 0, so 11 is December //do 03.12.2024 22:00
  async created() {
    // TODO: can remove after 03.12.2024 22:00
    document.title = this.$i18n.tc('news_list');
    let is4thDec = new Date().getTime() > this.newsProdHideLimit.getTime();
    //  return this.isDevEnv && isMore;
    if (!((this.isProductionEnv && is4thDec) || !this.isProductionEnv)) {
      this.goToHome();
    }

    await this.actionCanSeeAll().catch((err: any) => {
      logger.error(err);
    });

    let contactType: string = this.$route.fullPath.includes('/supplier') ? 'supplier' : '';
    await this.getCompanyZrsFromBackend(contactType);

    // if (this.initialRedirect) return; // (GSP-368) comment since change realisation (now in test)
    console.log('zz1 this.isUserLoggedInAndHasRights :>> ', this.isUserLoggedInAndHasRights);
    console.log('zz2 this.newsLoaded :>> ', this.newsLoaded);
    if (this.getAdmpNewsSearchData) {
      this.searchPayload = this.getAdmpNewsSearchData;
    }
    if (this.admpNewsSearchParams) {
      this.searchTerm = this.admpNewsSearchParams.filter;
    }

    if (this.isUserLoggedInAndHasRights) {
      await this.getNewsData();
    } else {
      // Mark loading as done so the "no access" message can show instead of endless spinner
      this.actionMarkAdmpNewsIsLoaded();
    }
  }

  goToHome() {
    this.$router.push({
      name: ROUTES.home,
    });
  }

  private isMounted = false; // avoid initial extra request in `selectionUpdateOptions`
  async mounted() {
    this.isMounted = true;
  }

  private async getNewsData() {
    const payload = {
      searchParams: this.admpNewsSearchParams,
      admpNewsSearchData: this.searchPayload,
    }; // sent search request from localStorage on reload

    await this.actionGetAdmpNewsList(payload)
      .then((result: any) => {
        logger.log('result :>> ', result);
        this.items.forEach((item: any) => {
          this.downloadImage(item);
        });
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  get items() {
    return this.getAdmpNews.items;
  }

  get headers() {
    let headers: {
      text: string | any;
      value: string;
      align?: string;
      class?: string | string[];
      sortable?: boolean;
      width?: string;
    }[] = [
      { text: this.$t('picture_small'), value: 'bild_small' },
      { text: this.$t('title_column'), value: 'title' },
      { text: this.$t('text_column'), value: 'text' },
      { text: this.$t('author'), value: 'created_by' }, //align: 'right'
      { text: this.$t('created_date'), value: 'created_on' },
      { text: this.$t('attachments'), value: 'number_of_attachments' },
      {
        text: this.$t('actions'),
        value: 'actions',
        sortable: false,
        width: '1%',
      },
    ];
    return headers;
  }

  private openAdmpNews(item: any) {
    logger.log('openAdmpNews item :>> ', item);
    const hashId = idMask.encode(item.id);

    this.$router.push({
      name: ROUTES.newsaddedit,
      params: { admpNewsId: hashId },
    });
  }

  onNewsAdd() {
    this.$router.push({
      name: ROUTES.newsaddedit,
      params: {
        admpNewsId: '0000000000000000',
      },
    });
  }

  deleteNews(record: AdmpNews) {
    this.$confirm
      .open(`${this.$t('delete_dialog_title')}`, `${this.$t('delete_dialog_text')}`, {
        cancelText: this.$t('delete_dialog_cancel'),
        okText: this.$t('delete_dialog_ok'),
      })
      .then(async (response: any) => {
        if (response) {
          await this.actionDeleteAdmpNews(record.id)
            .then(() => {
              console.log('new Date() :>> ', new Date(record.valid_from));
              // if Correct Dates, then reduce news notification count
              if (
                new Date() > new Date(record.valid_from) &&
                (!record.valit_until || new Date() <= new Date(record.valit_until))
              ) {
                this.actionUpdateUnreadNews(-1);
              }

              this.getNewsData();
            })
            .catch((err: any) => logger.error(err));
        }
      });
  }

  //#region GsUser admpNewsActions
  changeReadStatus(item: AdmpNews, readStatus: boolean) {
    NewsService.changeReadStatus(item, readStatus, this.actionUpsertAdmpNewsReadInfo);
  }

  markAsFavorite(item: AdmpNews, value: any) {
    NewsService.markAsFavorite(item, value, this.actionUpsertAdmpNewsReadInfo);
  }

  @Watch('items', { deep: true })
  onItemsChanged(newItems: any[]) {
    if (newItems && newItems.length) {
      newItems.forEach((item: any) => {
        this.downloadImage(item);
      });
    }
  }

  async downloadImage(item: AdmpNews) {
    // looking for the image file specifically in the ‘news_files’ folder
    const imageFile = item.news_files?.find((x: any) => x.bucket_name === 'admpnl-news-images');

    // If there is no image file at all (deleted)
    if (!imageFile) {
      if (this.getAdmpNewsImages && this.getAdmpNewsImages[item.id]) {
        this.actionUpdateAdmpNewsImages({ id: item.id, imageLink: null });
      }
      delete this.loadedImageVersions[item.id];
      item.noImage = true;
      return;
    }

    // File version (if the file is replaced, the id or filename will change)
    const currentVersion = `${imageFile.id}_${imageFile.filename}`;

    // If this exact version has already been downloaded — skip
    const isAlreadyLoaded = this.loadedImageVersions[item.id] === currentVersion && !!this.getAdmpNewsImages[item.id];

    if (isAlreadyLoaded) {
      return;
    }

    // Remember the new version
    this.loadedImageVersions[item.id] = currentVersion;

    // 4. Download the current image
    await NewsService.downloadImageForTile(
      item,
      false,
      this.actionGetNewsFileDownloadLink,
      this.actionUpdateAdmpNewsImages
    );
  }
  //#endregion

  private async selectionUpdateOptions(newVal: any, action: any) {
    if (this.isMounted && this.admpNewsIsLoading !== undefined) {
      this.searchTerm = newVal.filter;
      this.admpNewsSearchParams.dataOption = newVal;
      this.admpNewsSearchParams.filter = newVal.filter;
      this.getAdmpNewsListWithParams();
    }
  }

  private async getAdmpNewsListWithParams() {
    await this.actionGetAdmpNewsList({
      searchParams: this.admpNewsSearchParams,
      admpNewsSearchData: this.searchPayload,
    });
  }

  private searchTerm = '';
  private changeSearch(value: string) {
    // (GSP-074) if `menuDisabled` is true this means that facetSearch was completed and new request is sent (possibly for other field), otherwise (`menuDisabled` == false) user trying to send another request with the same unprocessed result from previous request (not choosing anything)
    console.log('this.admpNewsSearchParams :>> ', this.admpNewsSearchParams);
    console.log('this.admpNewsSearchParams.dataOption :>> ', this.admpNewsSearchParams.dataOption);
    if (value.length >= 2) {
      // this.optionsDto.filter = value;
      // this.optionsDto.page = 1; // (GSP-082) go to 1st page, when change search word
      this.admpNewsSearchParams.dataOption.filter = value;
      this.selectionUpdateOptions(this.admpNewsSearchParams.dataOption, '');
      // this.$emit('update:options', this.optionsDto, 'search');
    }
  }
  private resetSearch() {
    this.searchTerm = '';
    this.admpNewsSearchParams.filter = '';
    this.admpNewsSearchParams.dataOption.filter = '';
    this.selectionUpdateOptions(this.admpNewsSearchParams.dataOption, '');
  }
}
